import * as moment from "moment";
export class ActivityStreamModalComponent implements ng.IComponentOptions {
  public controller: any = ActivityStreamModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string = 
  `
  <div class="part">
  <div class="part-100 padding">
    <strong>Activity Stream</strong>
    <span class="pull-right pointer" ng-click="$ctrl.close()">&times;</span>
  </div>
  <div class="part-100 padding">
    <p class="activity-list" ng-repeat="activity in $ctrl.activities">
    <span class="circle bg-green" ng-if="activity.subject.type === 'dataset'"><i class="fa fa-fw fa-sitemap"></i></span>
    <span class="circle bg-purple" ng-if="(activity.subject.type === 'ministry')||activity.subject.type === 'agency'"><i class="fa fa-fw fa-group"></i></span>
    <span class="circle bg-orange" ng-if="(activity.subject.type === 'user')||!activity.subject"><i class="fa fa-fw fa-user"></i></span>
    <span>
    {{activity.user.fullname||'Anonymous'}} {{$ctrl.textMap[activity.action]}}&nbsp;
    {{activity.action === 'downloadDatasetFile'? $ctrl.typeMap[activity.object.id.type] + '&nbsp;':''}}
    <a ng-show="activity.object" ng-href="{{$ctrl.genPath(activity.object.type)}}{{activity.object.id._id}}">{{activity.object.id.display_name}}</a>
    <span ng-show="activity.object"> {{activity.actionType}} </span>
    <a ng-href="{{$ctrl.genPath(activity.subject.type)}}{{activity.subject.id._id}}">{{activity.subject.id.display_name}}</a>
    <span class="text-small text-gray">&nbsp;{{$ctrl.genTime(activity.createdOn)}}</span>
    </span>
    </p>
  </div>
  </div>
  `;
}

export class ActivityStreamModalController {
  public static $inject: Array<string> = ["$http", "$timeout"];
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public activities: Array<any>;
  public textMap: any;
  public typeMap: any;
  constructor (private $http: ng.IHttpService, private $timeout: ng.ITimeoutService) {
    $timeout(() => {
      if (this.resolve.datasetId) {
        $http.get(`${BASE}/api/activity/dataset/${this.resolve.datasetId}`)
        .then((d:any) => {
          this.activities = d.data;
        })
      }
      if (this.resolve.userId) {
        $http.get(`${BASE}/api/activity/user/${this.resolve.userId}`)
        .then((d:any) => {
          this.activities = d.data;
        })
      }

      this.textMap = {
        'updateDataset': "has updated dataset",
        'addDataset': "has added dataset",
        'deleteDataset': "has removed dataset",
        'restoreDataset': "has restored dataset",
        'addCleanedDataset': "has cleansed dataset",
        'downloadDatasetCSV': "has downloaded CSV files of dataset",
        'downloadDatasetFile': "has downloaded file for",
        'editUser': 'has updated profile',
        'addUser': 'has added user',
        'signup': 'has signup',
        'resetPassword': 'has reset password',
        'editDatatype': "has updated datatype",
        'addDatatype': "has added new datatype",
        'addAgency': "has added agency",
        'editAgency': "has updated agency",
        'addMinistry': "has added ministry",
        'editMinistry': "has updated ministry",
        'addAgencytoMinistry': "has added agency",
        'updateAgencytoMinistry': "has updated agency in",
        'removeAgencyFromMinistry': "has removed agency",
        'editClassification': "has updated classification",
        'addClassification': "has added classification",
        'updateConfiguration': "has updated configuration",
        'sendFeedback': "has sent a feedback"
      }

      this.typeMap = {
        'raw': 'Raw (Orginal) Dataset',
        'cleansed': 'Raw (Cleansed) Dataset',
        'aggregate': 'Aggregated Dataset'
      }
    })

  }
  public close() {
    this.modalInstance.dismiss();
  }
  public genPath(type) {
    switch(type) {
      case "dataset":
        return "#/dataset/"
    }
  }
  public genTime(date) {
    return moment(date).fromNow()
  }
}
